// import { merge, cloneDeep } from 'lodash';
import merge from 'lodash/merge';
import cloneDeep from 'lodash/cloneDeep';
import { chartOptions } from '@/data/chartJson';

const option = {
    "chart_id": "chart_5erpeWc1eWal_1596092336315",
    "active": true,
    "chartOptions": {
        "chart_id": "chart_5erpeWc1eWal_1596092336315",
        "chartAllType": "echarts|line|default",
        "chartPro": "echarts",
        "chartType": "line",
        "chartStyle": "default",
        "chartData": [
            [
                {
                    "v": "德国人的",
                    "ct": {
                        "fa": "General",
                        "t": "g"
                    },
                    "m": "德国人的",
                    "bg": "rgba(255,255,255)",
                    "bl": 0,
                    "it": 0,
                    "ff": 1,
                    "fs": 11,
                    "fc": "rgb(0, 0, 0)",
                    "ht": 1,
                    "vt": 0
                },
                {
                    "v": "尔尔",
                    "ct": {
                        "fa": "General",
                        "t": "g"
                    },
                    "m": "尔尔",
                    "bg": "rgba(255,255,255)",
                    "bl": 0,
                    "it": 0,
                    "ff": 1,
                    "fs": 11,
                    "fc": "rgb(0, 0, 0)",
                    "ht": 1,
                    "vt": 0
                },
                {
                    "v": "地方当然",
                    "ct": {
                        "fa": "General",
                        "t": "g"
                    },
                    "m": "地方当然",
                    "bg": "rgba(255,255,255)",
                    "bl": 0,
                    "it": 0,
                    "ff": 1,
                    "fs": 11,
                    "fc": "rgb(0, 0, 0)",
                    "ht": 1,
                    "vt": 0
                }
            ],
            [
                {
                    "v": "尔尔",
                    "ct": {
                        "fa": "General",
                        "t": "g"
                    },
                    "m": "尔尔",
                    "bg": "rgba(255,255,255)",
                    "bl": 0,
                    "it": 0,
                    "ff": 1,
                    "fs": 11,
                    "fc": "rgb(0, 0, 0)",
                    "ht": 1,
                    "vt": 0
                },
                {
                    "v": 1,
                    "ct": {
                        "fa": "General",
                        "t": "n"
                    },
                    "m": "1",
                    "bg": "rgba(255,255,255)",
                    "bl": 0,
                    "it": 0,
                    "ff": 1,
                    "fs": 11,
                    "fc": "rgb(0, 0, 0)",
                    "ht": 1,
                    "vt": 0
                },
                {
                    "v": 2,
                    "ct": {
                        "fa": "General",
                        "t": "n"
                    },
                    "m": "2",
                    "bg": "rgba(255,255,255)",
                    "bl": 0,
                    "it": 0,
                    "ff": 1,
                    "fs": 11,
                    "fc": "rgb(0, 0, 0)",
                    "ht": 1,
                    "vt": 0
                }
            ],
            [
                {
                    "v": "树人",
                    "ct": {
                        "fa": "General",
                        "t": "g"
                    },
                    "m": "树人",
                    "bg": "rgba(255,255,255)",
                    "bl": 0,
                    "it": 0,
                    "ff": 1,
                    "fs": 11,
                    "fc": "rgb(0, 0, 0)",
                    "ht": 1,
                    "vt": 0
                },
                {
                    "v": 3,
                    "ct": {
                        "fa": "General",
                        "t": "n"
                    },
                    "m": "3",
                    "bg": "rgba(255,255,255)",
                    "bl": 0,
                    "it": 0,
                    "ff": 1,
                    "fs": 11,
                    "fc": "rgb(0, 0, 0)",
                    "ht": 1,
                    "vt": 0
                },
                {
                    "v": 4,
                    "ct": {
                        "fa": "General",
                        "t": "n"
                    },
                    "m": "4",
                    "bg": "rgba(255,255,255)",
                    "bl": 0,
                    "it": 0,
                    "ff": 1,
                    "fs": 11,
                    "fc": "rgb(0, 0, 0)",
                    "ht": 1,
                    "vt": 0
                }
            ],
            [
                {
                    "v": "多个",
                    "ct": {
                        "fa": "General",
                        "t": "g"
                    },
                    "m": "多个",
                    "bg": "rgba(255,255,255)",
                    "bl": 0,
                    "it": 0,
                    "ff": 1,
                    "fs": 11,
                    "fc": "rgb(0, 0, 0)",
                    "ht": 1,
                    "vt": 0
                },
                {
                    "v": 5,
                    "ct": {
                        "fa": "General",
                        "t": "n"
                    },
                    "m": "5",
                    "bg": "rgba(255,255,255)",
                    "bl": 0,
                    "it": 0,
                    "ff": 1,
                    "fs": 11,
                    "fc": "rgb(0, 0, 0)",
                    "ht": 1,
                    "vt": 0
                },
                {
                    "v": 6,
                    "ct": {
                        "fa": "General",
                        "t": "n"
                    },
                    "m": "6",
                    "bg": "rgba(255,255,255)",
                    "bl": 0,
                    "it": 0,
                    "ff": 1,
                    "fs": 11,
                    "fc": "rgb(0, 0, 0)",
                    "ht": 1,
                    "vt": 0
                }
            ]
        ],
        "rangeArray": [
            {
                "row": [
                    17,
                    20
                ],
                "column": [
                    9,
                    11
                ],
                "row_focus": 17,
                "column_focus": 9,
                "left": 1077,
                "width": 140,
                "top": 357,
                "height": 31,
                "left_move": 1077,
                "width_move": 359,
                "top_move": 357,
                "height_move": 94
            }
        ],
        "rangeTxt": "J18:L21",
        "rangeColCheck": {
            "exits": true,
            "range": [
                0,
                0
            ]
        },
        "rangeRowCheck": {
            "exits": true,
            "range": [
                0,
                0
            ]
        },
        "rangeConfigCheck": false,
        "rangeSplitArray": {
            "title": {
                "row": [
                    0,
                    0
                ],
                "column": [
                    0,
                    0
                ]
            },
            "rowtitle": {
                "row": [
                    0,
                    0
                ],
                "column": [
                    1,
                    2
                ]
            },
            "coltitle": {
                "row": [
                    1,
                    3
                ],
                "column": [
                    0,
                    0
                ]
            },
            "content": {
                "row": [
                    1,
                    3
                ],
                "column": [
                    1,
                    2
                ]
            },
            "type": "normal",
            "range": {
                "row": [
                    17,
                    20
                ],
                "column": [
                    9,
                    11
                ],
                "row_focus": 17,
                "column_focus": 9,
                "left": 1077,
                "width": 140,
                "top": 357,
                "height": 31,
                "left_move": 1077,
                "width_move": 359,
                "top_move": 357,
                "height_move": 94
            }
        },
        "chartDataCache": {
            "label": [
                "尔尔",
                "地方当然"
            ],
            "xAxis": [
                "尔尔",
                "树人",
                "多个"
            ],
            "series": [
                [
                    1,
                    2
                ],
                [
                    3,
                    4
                ],
                [
                    5,
                    6
                ]
            ],
            "series_tpye": {
                "0": "num",
                "1": "num"
            }
        },
        "chartDataSeriesOrder": {
            "0": 0,
            "1": 1,
            "length": 2
        },
        "defaultOption": {
            "title": {
                "show": false,
                "text": "默认标题",
                "label": {
                    "fontSize": 12,
                    "color": "#333",
                    "fontFamily": "sans-serif",
                    "fontGroup": [],
                    "cusFontSize": 12
                },
                "position": {
                    "value": "left-top",
                    "offsetX": 40,
                    "offsetY": 50
                }
            },
            "subtitle": {
                "show": false,
                "text": "",
                "label": {
                    "fontSize": 12,
                    "color": "#333",
                    "fontFamily": "sans-serif",
                    "fontGroup": [],
                    "cusFontSize": 12
                },
                "distance": {
                    "value": "auto",
                    "cusGap": 40
                }
            },
            "config": {
                "color": "transparent",
                "fontFamily": "Sans-serif",
                "grid": {
                    "value": "normal",
                    "top": 5,
                    "left": 10,
                    "right": 20,
                    "bottom": 10
                }
            },
            "legend": {
                "show": true,
                "selectMode": "multiple",
                "selected": [
                    {
                        "seriesName": "衣服",
                        "isShow": true
                    },
                    {
                        "seriesName": "食材",
                        "isShow": true
                    },
                    {
                        "seriesName": "图书",
                        "isShow": true
                    }
                ],
                "label": {
                    "fontSize": 12,
                    "color": "#333",
                    "fontFamily": "sans-serif",
                    "fontGroup": [],
                    "cusFontSize": 12
                },
                "position": {
                    "value": "left-top",
                    "offsetX": 40,
                    "offsetY": 50,
                    "direction": "horizontal"
                },
                "width": {
                    "value": "auto",
                    "cusSize": 25
                },
                "height": {
                    "value": "auto",
                    "cusSize": 14
                },
                "distance": {
                    "value": "auto",
                    "cusGap": 10
                },
                "itemGap": 10,
                "data": [
                    "尔尔",
                    "地方当然"
                ]
            },
            "tooltip": {
                "show": true,
                "label": {
                    "fontSize": 12,
                    "color": "#333",
                    "fontFamily": "sans-serif",
                    "fontGroup": [],
                    "cusFontSize": 12
                },
                "backgroundColor": "rgba(50,50,50,0.7)",
                "triggerOn": "mousemove",
                "triggerType": "item",
                "axisPointer": {
                    "type": "line",
                    "style": {
                        "color": "#555",
                        "width": "normal",
                        "type": "solid"
                    }
                },
                "format": [
                    {
                        "seriesName": "衣服",
                        "prefix": "",
                        "suffix": "",
                        "ratio": 1,
                        "digit": "auto"
                    },
                    {
                        "seriesName": "食材",
                        "prefix": "",
                        "suffix": "",
                        "ratio": 1,
                        "digit": "auto"
                    },
                    {
                        "seriesName": "图书",
                        "prefix": "",
                        "suffix": "",
                        "ratio": 1,
                        "digit": "auto"
                    }
                ],
                "position": "auto"
            },
            "axis": {
                "axisType": "xAxisDown",
                "xAxisUp": {
                    "show": false,
                    "title": {
                        "showTitle": false,
                        "text": "",
                        "nameGap": 15,
                        "rotate": 0,
                        "label": {
                            "fontSize": 12,
                            "color": "#333",
                            "fontFamily": "sans-serif",
                            "fontGroup": [],
                            "cusFontSize": 12
                        },
                        "fzPosition": "end"
                    },
                    "name": "显示X轴",
                    "inverse": false,
                    "tickLine": {
                        "show": true,
                        "width": 1,
                        "color": "auto"
                    },
                    "tick": {
                        "show": true,
                        "position": "outside",
                        "length": 5,
                        "width": 1,
                        "color": "auto"
                    },
                    "tickLabel": {
                        "show": true,
                        "label": {
                            "fontSize": 12,
                            "color": "#333",
                            "fontFamily": "sans-serif",
                            "fontGroup": [],
                            "cusFontSize": 12
                        },
                        "rotate": 0,
                        "prefix": "",
                        "suffix": "",
                        "optimize": 0,
                        "distance": 0,
                        "min": "auto",
                        "max": "auto",
                        "ratio": 1,
                        "digit": "auto"
                    },
                    "netLine": {
                        "show": false,
                        "width": 1,
                        "type": "solid",
                        "color": "auto",
                        "interval": {
                            "value": "auto",
                            "cusNumber": 0
                        }
                    },
                    "netArea": {
                        "show": false,
                        "interval": {
                            "value": "auto",
                            "cusNumber": 0
                        },
                        "colorOne": "auto",
                        "colorTwo": "auto"
                    },
                    "axisLine": {
                        "onZero": false
                    }
                },
                "xAxisDown": {
                    "show": true,
                    "title": {
                        "showTitle": false,
                        "text": "",
                        "nameGap": 15,
                        "rotate": 0,
                        "label": {
                            "fontSize": 12,
                            "color": "#333",
                            "fontFamily": "sans-serif",
                            "fontGroup": [],
                            "cusFontSize": 12
                        },
                        "fzPosition": "end"
                    },
                    "name": "显示X轴",
                    "inverse": false,
                    "tickLine": {
                        "show": true,
                        "width": 1,
                        "color": "auto"
                    },
                    "tick": {
                        "show": true,
                        "position": "outside",
                        "length": 5,
                        "width": 1,
                        "color": "auto"
                    },
                    "tickLabel": {
                        "show": true,
                        "label": {
                            "fontSize": 12,
                            "color": "#333",
                            "fontFamily": "sans-serif",
                            "fontGroup": [],
                            "cusFontSize": 12
                        },
                        "rotate": 0,
                        "prefix": "",
                        "suffix": "",
                        "optimize": 0,
                        "distance": 0,
                        "min": null,
                        "max": null,
                        "ratio": 1,
                        "digit": "auto"
                    },
                    "netLine": {
                        "show": false,
                        "width": 1,
                        "type": "solid",
                        "color": "auto",
                        "interval": {
                            "value": "auto",
                            "cusNumber": 0
                        }
                    },
                    "netArea": {
                        "show": false,
                        "interval": {
                            "value": "auto",
                            "cusNumber": 0
                        },
                        "colorOne": "auto",
                        "colorTwo": "auto"
                    },
                    "data": [
                        "尔尔",
                        "树人",
                        "多个"
                    ],
                    "type": "category"
                },
                "yAxisLeft": {
                    "show": true,
                    "title": {
                        "showTitle": false,
                        "text": "",
                        "nameGap": 15,
                        "rotate": 0,
                        "label": {
                            "fontSize": 12,
                            "color": "#333",
                            "fontFamily": "sans-serif",
                            "fontGroup": [],
                            "cusFontSize": 12
                        },
                        "fzPosition": "end"
                    },
                    "name": "显示Y轴",
                    "inverse": false,
                    "tickLine": {
                        "show": true,
                        "width": 1,
                        "color": "auto"
                    },
                    "tick": {
                        "show": true,
                        "position": "outside",
                        "length": 5,
                        "width": 1,
                        "color": "auto"
                    },
                    "tickLabel": {
                        "show": true,
                        "label": {
                            "fontSize": 12,
                            "color": "#333",
                            "fontFamily": "sans-serif",
                            "fontGroup": [],
                            "cusFontSize": 12
                        },
                        "rotate": 0,
                        "formatter": {
                            "prefix": "",
                            "suffix": "",
                            "ratio": 1,
                            "digit": "auto"
                        },
                        "split": 5,
                        "min": null,
                        "max": null,
                        "prefix": "",
                        "suffix": "",
                        "ratio": 1,
                        "digit": "auto",
                        "distance": 0
                    },
                    "netLine": {
                        "show": false,
                        "width": 1,
                        "type": "solid",
                        "color": "auto",
                        "interval": {
                            "value": "auto",
                            "cusNumber": 0
                        }
                    },
                    "netArea": {
                        "show": false,
                        "interval": {
                            "value": "auto",
                            "cusNumber": 0
                        },
                        "colorOne": "auto",
                        "colorTwo": "auto"
                    },
                    "type": "value"
                },
                "yAxisRight": {
                    "show": false,
                    "title": {
                        "showTitle": false,
                        "text": "",
                        "nameGap": 15,
                        "rotate": 0,
                        "label": {
                            "fontSize": 12,
                            "color": "#333",
                            "fontFamily": "sans-serif",
                            "fontGroup": [],
                            "cusFontSize": 12
                        },
                        "fzPosition": "end"
                    },
                    "name": "显示Y轴",
                    "inverse": false,
                    "tickLine": {
                        "show": true,
                        "width": 1,
                        "color": "auto"
                    },
                    "tick": {
                        "show": true,
                        "position": "outside",
                        "length": 5,
                        "width": 1,
                        "color": "auto"
                    },
                    "tickLabel": {
                        "show": true,
                        "label": {
                            "fontSize": 12,
                            "color": "#333",
                            "fontFamily": "sans-serif",
                            "fontGroup": [],
                            "cusFontSize": 12
                        },
                        "rotate": 0,
                        "formatter": {
                            "prefix": "",
                            "suffix": "",
                            "ratio": 1,
                            "digit": "auto"
                        },
                        "split": 5,
                        "min": null,
                        "max": null,
                        "prefix": "",
                        "suffix": "",
                        "ratio": 1,
                        "digit": "auto",
                        "distance": 0
                    },
                    "netLine": {
                        "show": false,
                        "width": 1,
                        "type": "solid",
                        "color": "auto",
                        "interval": {
                            "value": "auto",
                            "cusNumber": 0
                        }
                    },
                    "netArea": {
                        "show": false,
                        "interval": {
                            "value": "auto",
                            "cusNumber": 0
                        },
                        "colorOne": "auto",
                        "colorTwo": "auto"
                    }
                }
            },
            "series": [
                {
                    "itemStyle": {
                        "color": null,
                        "borderColor": "#000",
                        "borderType": "solid",
                        "borderWidth": 1
                    },
                    "lineStyle": {
                        "color": null,
                        "width": 1,
                        "type": "solid"
                    },
                    "data": [
                        1,
                        3,
                        5
                    ],
                    "type": "line",
                    "name": "尔尔",
                    "markPoint": {
                        "data": []
                    },
                    "markLine": {
                        "data": []
                    },
                    "markArea": {
                        "data": []
                    }
                },
                {
                    "itemStyle": {
                        "color": null,
                        "borderColor": "#000",
                        "borderType": "solid",
                        "borderWidth": 1
                    },
                    "lineStyle": {
                        "color": null,
                        "width": 1,
                        "type": "solid"
                    },
                    "data": [
                        2,
                        4,
                        6
                    ],
                    "type": "line",
                    "name": "地方当然",
                    "markPoint": {
                        "data": []
                    },
                    "markLine": {
                        "data": []
                    },
                    "markArea": {
                        "data": []
                    }
                }
            ],
            "seriesData": [
                [
                    1,
                    3,
                    5
                ],
                [
                    2,
                    4,
                    6
                ]
            ]
        }
    }
}

export default {
     // store all chart objects
     chartLists:[
        {
            "chart_id": "chart_5erpeWc1eWal_1596092336315",
            "active": true,
            "chartOptions": {
                "chart_id": "chart_5erpeWc1eWal_1596092336315",
                "chartAllType": "echarts|line|default",
                "chartPro": "echarts",
                "chartType": "line",
                "chartStyle": "default",
                "chartData": [
                    [
                        {
                            "v": "德国人的",
                            "ct": {
                                "fa": "General",
                                "t": "g"
                            },
                            "m": "德国人的",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        },
                        {
                            "v": "尔尔",
                            "ct": {
                                "fa": "General",
                                "t": "g"
                            },
                            "m": "尔尔",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        },
                        {
                            "v": "地方当然",
                            "ct": {
                                "fa": "General",
                                "t": "g"
                            },
                            "m": "地方当然",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        }
                    ],
                    [
                        {
                            "v": "尔尔",
                            "ct": {
                                "fa": "General",
                                "t": "g"
                            },
                            "m": "尔尔",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        },
                        {
                            "v": 1,
                            "ct": {
                                "fa": "General",
                                "t": "n"
                            },
                            "m": "1",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        },
                        {
                            "v": 2,
                            "ct": {
                                "fa": "General",
                                "t": "n"
                            },
                            "m": "2",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        }
                    ],
                    [
                        {
                            "v": "树人",
                            "ct": {
                                "fa": "General",
                                "t": "g"
                            },
                            "m": "树人",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        },
                        {
                            "v": 3,
                            "ct": {
                                "fa": "General",
                                "t": "n"
                            },
                            "m": "3",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        },
                        {
                            "v": 4,
                            "ct": {
                                "fa": "General",
                                "t": "n"
                            },
                            "m": "4",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        }
                    ],
                    [
                        {
                            "v": "多个",
                            "ct": {
                                "fa": "General",
                                "t": "g"
                            },
                            "m": "多个",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        },
                        {
                            "v": 5,
                            "ct": {
                                "fa": "General",
                                "t": "n"
                            },
                            "m": "5",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        },
                        {
                            "v": 6,
                            "ct": {
                                "fa": "General",
                                "t": "n"
                            },
                            "m": "6",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        }
                    ]
                ],
                "rangeArray": [
                    {
                        "row": [
                            17,
                            20
                        ],
                        "column": [
                            9,
                            11
                        ],
                        "row_focus": 17,
                        "column_focus": 9,
                        "left": 1077,
                        "width": 140,
                        "top": 357,
                        "height": 31,
                        "left_move": 1077,
                        "width_move": 359,
                        "top_move": 357,
                        "height_move": 94
                    }
                ],
                "rangeTxt": "J18:L21",
                "rangeColCheck": {
                    "exits": true,
                    "range": [
                        0,
                        0
                    ]
                },
                "rangeRowCheck": {
                    "exits": true,
                    "range": [
                        0,
                        0
                    ]
                },
                "rangeConfigCheck": false,
                "rangeSplitArray": {
                    "title": {
                        "row": [
                            0,
                            0
                        ],
                        "column": [
                            0,
                            0
                        ]
                    },
                    "rowtitle": {
                        "row": [
                            0,
                            0
                        ],
                        "column": [
                            1,
                            2
                        ]
                    },
                    "coltitle": {
                        "row": [
                            1,
                            3
                        ],
                        "column": [
                            0,
                            0
                        ]
                    },
                    "content": {
                        "row": [
                            1,
                            3
                        ],
                        "column": [
                            1,
                            2
                        ]
                    },
                    "type": "normal",
                    "range": {
                        "row": [
                            17,
                            20
                        ],
                        "column": [
                            9,
                            11
                        ],
                        "row_focus": 17,
                        "column_focus": 9,
                        "left": 1077,
                        "width": 140,
                        "top": 357,
                        "height": 31,
                        "left_move": 1077,
                        "width_move": 359,
                        "top_move": 357,
                        "height_move": 94
                    }
                },
                "chartDataCache": {
                    "label": [
                        "尔尔",
                        "地方当然"
                    ],
                    "xAxis": [
                        "尔尔",
                        "树人",
                        "多个"
                    ],
                    "series": [
                        [
                            1,
                            2
                        ],
                        [
                            3,
                            4
                        ],
                        [
                            5,
                            6
                        ]
                    ],
                    "series_tpye": {
                        "0": "num",
                        "1": "num"
                    }
                },
                "chartDataSeriesOrder": {
                    "0": 0,
                    "1": 1,
                    "length": 2
                },
                "defaultOption": {
                    "title": {
                        "show": false,
                        "text": "默认标题",
                        "label": {
                            "fontSize": 12,
                            "color": "#333",
                            "fontFamily": "sans-serif",
                            "fontGroup": [],
                            "cusFontSize": 12
                        },
                        "position": {
                            "value": "left-top",
                            "offsetX": 40,
                            "offsetY": 50
                        }
                    },
                    "subtitle": {
                        "show": false,
                        "text": "",
                        "label": {
                            "fontSize": 12,
                            "color": "#333",
                            "fontFamily": "sans-serif",
                            "fontGroup": [],
                            "cusFontSize": 12
                        },
                        "distance": {
                            "value": "auto",
                            "cusGap": 40
                        }
                    },
                    "config": {
                        "color": "transparent",
                        "fontFamily": "Sans-serif",
                        "grid": {
                            "value": "normal",
                            "top": 5,
                            "left": 10,
                            "right": 20,
                            "bottom": 10
                        }
                    },
                    "legend": {
                        "show": true,
                        "selectMode": "multiple",
                        "selected": [
                            {
                                "seriesName": "衣服",
                                "isShow": true
                            },
                            {
                                "seriesName": "食材",
                                "isShow": true
                            },
                            {
                                "seriesName": "图书",
                                "isShow": true
                            }
                        ],
                        "label": {
                            "fontSize": 12,
                            "color": "#333",
                            "fontFamily": "sans-serif",
                            "fontGroup": [],
                            "cusFontSize": 12
                        },
                        "position": {
                            "value": "left-top",
                            "offsetX": 40,
                            "offsetY": 50,
                            "direction": "horizontal"
                        },
                        "width": {
                            "value": "auto",
                            "cusSize": 25
                        },
                        "height": {
                            "value": "auto",
                            "cusSize": 14
                        },
                        "distance": {
                            "value": "auto",
                            "cusGap": 10
                        },
                        "itemGap": 10,
                        "data": [
                            "尔尔",
                            "地方当然"
                        ]
                    },
                    "tooltip": {
                        "show": true,
                        "label": {
                            "fontSize": 12,
                            "color": "#333",
                            "fontFamily": "sans-serif",
                            "fontGroup": [],
                            "cusFontSize": 12
                        },
                        "backgroundColor": "rgba(50,50,50,0.7)",
                        "triggerOn": "mousemove",
                        "triggerType": "item",
                        "axisPointer": {
                            "type": "line",
                            "style": {
                                "color": "#555",
                                "width": "normal",
                                "type": "solid"
                            }
                        },
                        "format": [
                            {
                                "seriesName": "衣服",
                                "prefix": "",
                                "suffix": "",
                                "ratio": 1,
                                "digit": "auto"
                            },
                            {
                                "seriesName": "食材",
                                "prefix": "",
                                "suffix": "",
                                "ratio": 1,
                                "digit": "auto"
                            },
                            {
                                "seriesName": "图书",
                                "prefix": "",
                                "suffix": "",
                                "ratio": 1,
                                "digit": "auto"
                            }
                        ],
                        "position": "auto"
                    },
                    "axis": {
                        "axisType": "xAxisDown",
                        "xAxisUp": {
                            "show": false,
                            "title": {
                                "showTitle": false,
                                "text": "",
                                "nameGap": 15,
                                "rotate": 0,
                                "label": {
                                    "fontSize": 12,
                                    "color": "#333",
                                    "fontFamily": "sans-serif",
                                    "fontGroup": [],
                                    "cusFontSize": 12
                                },
                                "fzPosition": "end"
                            },
                            "name": "显示X轴",
                            "inverse": false,
                            "tickLine": {
                                "show": true,
                                "width": 1,
                                "color": "auto"
                            },
                            "tick": {
                                "show": true,
                                "position": "outside",
                                "length": 5,
                                "width": 1,
                                "color": "auto"
                            },
                            "tickLabel": {
                                "show": true,
                                "label": {
                                    "fontSize": 12,
                                    "color": "#333",
                                    "fontFamily": "sans-serif",
                                    "fontGroup": [],
                                    "cusFontSize": 12
                                },
                                "rotate": 0,
                                "prefix": "",
                                "suffix": "",
                                "optimize": 0,
                                "distance": 0,
                                "min": "auto",
                                "max": "auto",
                                "ratio": 1,
                                "digit": "auto"
                            },
                            "netLine": {
                                "show": false,
                                "width": 1,
                                "type": "solid",
                                "color": "auto",
                                "interval": {
                                    "value": "auto",
                                    "cusNumber": 0
                                }
                            },
                            "netArea": {
                                "show": false,
                                "interval": {
                                    "value": "auto",
                                    "cusNumber": 0
                                },
                                "colorOne": "auto",
                                "colorTwo": "auto"
                            },
                            "axisLine": {
                                "onZero": false
                            }
                        },
                        "xAxisDown": {
                            "show": true,
                            "title": {
                                "showTitle": false,
                                "text": "",
                                "nameGap": 15,
                                "rotate": 0,
                                "label": {
                                    "fontSize": 12,
                                    "color": "#333",
                                    "fontFamily": "sans-serif",
                                    "fontGroup": [],
                                    "cusFontSize": 12
                                },
                                "fzPosition": "end"
                            },
                            "name": "显示X轴",
                            "inverse": false,
                            "tickLine": {
                                "show": true,
                                "width": 1,
                                "color": "auto"
                            },
                            "tick": {
                                "show": true,
                                "position": "outside",
                                "length": 5,
                                "width": 1,
                                "color": "auto"
                            },
                            "tickLabel": {
                                "show": true,
                                "label": {
                                    "fontSize": 12,
                                    "color": "#333",
                                    "fontFamily": "sans-serif",
                                    "fontGroup": [],
                                    "cusFontSize": 12
                                },
                                "rotate": 0,
                                "prefix": "",
                                "suffix": "",
                                "optimize": 0,
                                "distance": 0,
                                "min": null,
                                "max": null,
                                "ratio": 1,
                                "digit": "auto"
                            },
                            "netLine": {
                                "show": false,
                                "width": 1,
                                "type": "solid",
                                "color": "auto",
                                "interval": {
                                    "value": "auto",
                                    "cusNumber": 0
                                }
                            },
                            "netArea": {
                                "show": false,
                                "interval": {
                                    "value": "auto",
                                    "cusNumber": 0
                                },
                                "colorOne": "auto",
                                "colorTwo": "auto"
                            },
                            "data": [
                                "尔尔",
                                "树人",
                                "多个"
                            ],
                            "type": "category"
                        },
                        "yAxisLeft": {
                            "show": true,
                            "title": {
                                "showTitle": false,
                                "text": "",
                                "nameGap": 15,
                                "rotate": 0,
                                "label": {
                                    "fontSize": 12,
                                    "color": "#333",
                                    "fontFamily": "sans-serif",
                                    "fontGroup": [],
                                    "cusFontSize": 12
                                },
                                "fzPosition": "end"
                            },
                            "name": "显示Y轴",
                            "inverse": false,
                            "tickLine": {
                                "show": true,
                                "width": 1,
                                "color": "auto"
                            },
                            "tick": {
                                "show": true,
                                "position": "outside",
                                "length": 5,
                                "width": 1,
                                "color": "auto"
                            },
                            "tickLabel": {
                                "show": true,
                                "label": {
                                    "fontSize": 12,
                                    "color": "#333",
                                    "fontFamily": "sans-serif",
                                    "fontGroup": [],
                                    "cusFontSize": 12
                                },
                                "rotate": 0,
                                "formatter": {
                                    "prefix": "",
                                    "suffix": "",
                                    "ratio": 1,
                                    "digit": "auto"
                                },
                                "split": 5,
                                "min": null,
                                "max": null,
                                "prefix": "",
                                "suffix": "",
                                "ratio": 1,
                                "digit": "auto",
                                "distance": 0
                            },
                            "netLine": {
                                "show": false,
                                "width": 1,
                                "type": "solid",
                                "color": "auto",
                                "interval": {
                                    "value": "auto",
                                    "cusNumber": 0
                                }
                            },
                            "netArea": {
                                "show": false,
                                "interval": {
                                    "value": "auto",
                                    "cusNumber": 0
                                },
                                "colorOne": "auto",
                                "colorTwo": "auto"
                            },
                            "type": "value"
                        },
                        "yAxisRight": {
                            "show": false,
                            "title": {
                                "showTitle": false,
                                "text": "",
                                "nameGap": 15,
                                "rotate": 0,
                                "label": {
                                    "fontSize": 12,
                                    "color": "#333",
                                    "fontFamily": "sans-serif",
                                    "fontGroup": [],
                                    "cusFontSize": 12
                                },
                                "fzPosition": "end"
                            },
                            "name": "显示Y轴",
                            "inverse": false,
                            "tickLine": {
                                "show": true,
                                "width": 1,
                                "color": "auto"
                            },
                            "tick": {
                                "show": true,
                                "position": "outside",
                                "length": 5,
                                "width": 1,
                                "color": "auto"
                            },
                            "tickLabel": {
                                "show": true,
                                "label": {
                                    "fontSize": 12,
                                    "color": "#333",
                                    "fontFamily": "sans-serif",
                                    "fontGroup": [],
                                    "cusFontSize": 12
                                },
                                "rotate": 0,
                                "formatter": {
                                    "prefix": "",
                                    "suffix": "",
                                    "ratio": 1,
                                    "digit": "auto"
                                },
                                "split": 5,
                                "min": null,
                                "max": null,
                                "prefix": "",
                                "suffix": "",
                                "ratio": 1,
                                "digit": "auto",
                                "distance": 0
                            },
                            "netLine": {
                                "show": false,
                                "width": 1,
                                "type": "solid",
                                "color": "auto",
                                "interval": {
                                    "value": "auto",
                                    "cusNumber": 0
                                }
                            },
                            "netArea": {
                                "show": false,
                                "interval": {
                                    "value": "auto",
                                    "cusNumber": 0
                                },
                                "colorOne": "auto",
                                "colorTwo": "auto"
                            }
                        }
                    },
                    "series": [
                        {
                            "itemStyle": {
                                "color": null,
                                "borderColor": "#000",
                                "borderType": "solid",
                                "borderWidth": 1
                            },
                            "lineStyle": {
                                "color": null,
                                "width": 1,
                                "type": "solid"
                            },
                            "data": [
                                1,
                                3,
                                5
                            ],
                            "type": "line",
                            "name": "尔尔",
                            "markPoint": {
                                "data": []
                            },
                            "markLine": {
                                "data": []
                            },
                            "markArea": {
                                "data": []
                            }
                        },
                        {
                            "itemStyle": {
                                "color": null,
                                "borderColor": "#000",
                                "borderType": "solid",
                                "borderWidth": 1
                            },
                            "lineStyle": {
                                "color": null,
                                "width": 1,
                                "type": "solid"
                            },
                            "data": [
                                2,
                                4,
                                6
                            ],
                            "type": "line",
                            "name": "地方当然",
                            "markPoint": {
                                "data": []
                            },
                            "markLine": {
                                "data": []
                            },
                            "markArea": {
                                "data": []
                            }
                        }
                    ],
                    "seriesData": [
                        [
                            1,
                            3,
                            5
                        ],
                        [
                            2,
                            4,
                            6
                        ]
                    ]
                }
            }
        }, {
            "chart_id": "chart_5erpeWc1eWal_1596093236310",
            "active": true,
            "chartOptions": {
                "chart_id": "chart_5erpeWc1eWal_1596093236310",
                "chartAllType": "echarts|line|default",
                "chartPro": "echarts",
                "chartType": "line",
                "chartStyle": "default",
                "chartData": [
                    [
                        {
                            "v": "德国人的",
                            "ct": {
                                "fa": "General",
                                "t": "g"
                            },
                            "m": "德国人的",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        },
                        {
                            "v": "尔尔",
                            "ct": {
                                "fa": "General",
                                "t": "g"
                            },
                            "m": "尔尔",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        },
                        {
                            "v": "地方当然",
                            "ct": {
                                "fa": "General",
                                "t": "g"
                            },
                            "m": "地方当然",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        }
                    ],
                    [
                        {
                            "v": "尔尔",
                            "ct": {
                                "fa": "General",
                                "t": "g"
                            },
                            "m": "尔尔",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        },
                        {
                            "v": 1,
                            "ct": {
                                "fa": "General",
                                "t": "n"
                            },
                            "m": "1",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        },
                        {
                            "v": 2,
                            "ct": {
                                "fa": "General",
                                "t": "n"
                            },
                            "m": "2",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        }
                    ],
                    [
                        {
                            "v": "树人",
                            "ct": {
                                "fa": "General",
                                "t": "g"
                            },
                            "m": "树人",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        },
                        {
                            "v": 3,
                            "ct": {
                                "fa": "General",
                                "t": "n"
                            },
                            "m": "3",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        },
                        {
                            "v": 4,
                            "ct": {
                                "fa": "General",
                                "t": "n"
                            },
                            "m": "4",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        }
                    ],
                    [
                        {
                            "v": "多个",
                            "ct": {
                                "fa": "General",
                                "t": "g"
                            },
                            "m": "多个",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        },
                        {
                            "v": 5,
                            "ct": {
                                "fa": "General",
                                "t": "n"
                            },
                            "m": "5",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        },
                        {
                            "v": 6,
                            "ct": {
                                "fa": "General",
                                "t": "n"
                            },
                            "m": "6",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        }
                    ]
                ],
                "rangeArray": [
                    {
                        "row": [
                            17,
                            20
                        ],
                        "column": [
                            9,
                            11
                        ],
                        "row_focus": 17,
                        "column_focus": 9,
                        "left": 1077,
                        "width": 140,
                        "top": 357,
                        "height": 31,
                        "left_move": 1077,
                        "width_move": 359,
                        "top_move": 357,
                        "height_move": 94
                    }
                ],
                "rangeTxt": "J18:L21",
                "rangeColCheck": {
                    "exits": true,
                    "range": [
                        0,
                        0
                    ]
                },
                "rangeRowCheck": {
                    "exits": true,
                    "range": [
                        0,
                        0
                    ]
                },
                "rangeConfigCheck": false,
                "rangeSplitArray": {
                    "title": {
                        "row": [
                            0,
                            0
                        ],
                        "column": [
                            0,
                            0
                        ]
                    },
                    "rowtitle": {
                        "row": [
                            0,
                            0
                        ],
                        "column": [
                            1,
                            2
                        ]
                    },
                    "coltitle": {
                        "row": [
                            1,
                            3
                        ],
                        "column": [
                            0,
                            0
                        ]
                    },
                    "content": {
                        "row": [
                            1,
                            3
                        ],
                        "column": [
                            1,
                            2
                        ]
                    },
                    "type": "normal",
                    "range": {
                        "row": [
                            17,
                            20
                        ],
                        "column": [
                            9,
                            11
                        ],
                        "row_focus": 17,
                        "column_focus": 9,
                        "left": 1077,
                        "width": 140,
                        "top": 357,
                        "height": 31,
                        "left_move": 1077,
                        "width_move": 359,
                        "top_move": 357,
                        "height_move": 94
                    }
                },
                "chartDataCache": {
                    "label": [
                        "尔尔",
                        "地方当然"
                    ],
                    "xAxis": [
                        "尔尔",
                        "树人",
                        "多个"
                    ],
                    "series": [
                        [
                            1,
                            2
                        ],
                        [
                            3,
                            4
                        ],
                        [
                            5,
                            6
                        ]
                    ],
                    "series_tpye": {
                        "0": "num",
                        "1": "num"
                    }
                },
                "chartDataSeriesOrder": {
                    "0": 0,
                    "1": 1,
                    "length": 2
                },
                "defaultOption": {
                    "title": {
                        "show": false,
                        "text": "默认标题",
                        "label": {
                            "fontSize": 12,
                            "color": "#333",
                            "fontFamily": "sans-serif",
                            "fontGroup": [],
                            "cusFontSize": 12
                        },
                        "position": {
                            "value": "left-top",
                            "offsetX": 40,
                            "offsetY": 50
                        }
                    },
                    "subtitle": {
                        "show": false,
                        "text": "",
                        "label": {
                            "fontSize": 12,
                            "color": "#333",
                            "fontFamily": "sans-serif",
                            "fontGroup": [],
                            "cusFontSize": 12
                        },
                        "distance": {
                            "value": "auto",
                            "cusGap": 40
                        }
                    },
                    "config": {
                        "color": "transparent",
                        "fontFamily": "Sans-serif",
                        "grid": {
                            "value": "normal",
                            "top": 5,
                            "left": 10,
                            "right": 20,
                            "bottom": 10
                        }
                    },
                    "legend": {
                        "show": true,
                        "selectMode": "multiple",
                        "selected": [
                            {
                                "seriesName": "衣服",
                                "isShow": true
                            },
                            {
                                "seriesName": "食材",
                                "isShow": true
                            },
                            {
                                "seriesName": "图书",
                                "isShow": true
                            }
                        ],
                        "label": {
                            "fontSize": 12,
                            "color": "#333",
                            "fontFamily": "sans-serif",
                            "fontGroup": [],
                            "cusFontSize": 12
                        },
                        "position": {
                            "value": "left-top",
                            "offsetX": 40,
                            "offsetY": 50,
                            "direction": "horizontal"
                        },
                        "width": {
                            "value": "auto",
                            "cusSize": 25
                        },
                        "height": {
                            "value": "auto",
                            "cusSize": 14
                        },
                        "distance": {
                            "value": "auto",
                            "cusGap": 10
                        },
                        "itemGap": 10,
                        "data": [
                            "尔尔",
                            "地方当然"
                        ]
                    },
                    "tooltip": {
                        "show": true,
                        "label": {
                            "fontSize": 12,
                            "color": "#333",
                            "fontFamily": "sans-serif",
                            "fontGroup": [],
                            "cusFontSize": 12
                        },
                        "backgroundColor": "rgba(50,50,50,0.7)",
                        "triggerOn": "mousemove",
                        "triggerType": "item",
                        "axisPointer": {
                            "type": "line",
                            "style": {
                                "color": "#555",
                                "width": "normal",
                                "type": "solid"
                            }
                        },
                        "format": [
                            {
                                "seriesName": "衣服",
                                "prefix": "",
                                "suffix": "",
                                "ratio": 1,
                                "digit": "auto"
                            },
                            {
                                "seriesName": "食材",
                                "prefix": "",
                                "suffix": "",
                                "ratio": 1,
                                "digit": "auto"
                            },
                            {
                                "seriesName": "图书",
                                "prefix": "",
                                "suffix": "",
                                "ratio": 1,
                                "digit": "auto"
                            }
                        ],
                        "position": "auto"
                    },
                    "axis": {
                        "axisType": "xAxisDown",
                        "xAxisUp": {
                            "show": false,
                            "title": {
                                "showTitle": false,
                                "text": "",
                                "nameGap": 15,
                                "rotate": 0,
                                "label": {
                                    "fontSize": 12,
                                    "color": "#333",
                                    "fontFamily": "sans-serif",
                                    "fontGroup": [],
                                    "cusFontSize": 12
                                },
                                "fzPosition": "end"
                            },
                            "name": "显示X轴",
                            "inverse": false,
                            "tickLine": {
                                "show": true,
                                "width": 1,
                                "color": "auto"
                            },
                            "tick": {
                                "show": true,
                                "position": "outside",
                                "length": 5,
                                "width": 1,
                                "color": "auto"
                            },
                            "tickLabel": {
                                "show": true,
                                "label": {
                                    "fontSize": 12,
                                    "color": "#333",
                                    "fontFamily": "sans-serif",
                                    "fontGroup": [],
                                    "cusFontSize": 12
                                },
                                "rotate": 0,
                                "prefix": "",
                                "suffix": "",
                                "optimize": 0,
                                "distance": 0,
                                "min": "auto",
                                "max": "auto",
                                "ratio": 1,
                                "digit": "auto"
                            },
                            "netLine": {
                                "show": false,
                                "width": 1,
                                "type": "solid",
                                "color": "auto",
                                "interval": {
                                    "value": "auto",
                                    "cusNumber": 0
                                }
                            },
                            "netArea": {
                                "show": false,
                                "interval": {
                                    "value": "auto",
                                    "cusNumber": 0
                                },
                                "colorOne": "auto",
                                "colorTwo": "auto"
                            },
                            "axisLine": {
                                "onZero": false
                            }
                        },
                        "xAxisDown": {
                            "show": true,
                            "title": {
                                "showTitle": false,
                                "text": "",
                                "nameGap": 15,
                                "rotate": 0,
                                "label": {
                                    "fontSize": 12,
                                    "color": "#333",
                                    "fontFamily": "sans-serif",
                                    "fontGroup": [],
                                    "cusFontSize": 12
                                },
                                "fzPosition": "end"
                            },
                            "name": "显示X轴",
                            "inverse": false,
                            "tickLine": {
                                "show": true,
                                "width": 1,
                                "color": "auto"
                            },
                            "tick": {
                                "show": true,
                                "position": "outside",
                                "length": 5,
                                "width": 1,
                                "color": "auto"
                            },
                            "tickLabel": {
                                "show": true,
                                "label": {
                                    "fontSize": 12,
                                    "color": "#333",
                                    "fontFamily": "sans-serif",
                                    "fontGroup": [],
                                    "cusFontSize": 12
                                },
                                "rotate": 0,
                                "prefix": "",
                                "suffix": "",
                                "optimize": 0,
                                "distance": 0,
                                "min": null,
                                "max": null,
                                "ratio": 1,
                                "digit": "auto"
                            },
                            "netLine": {
                                "show": false,
                                "width": 1,
                                "type": "solid",
                                "color": "auto",
                                "interval": {
                                    "value": "auto",
                                    "cusNumber": 0
                                }
                            },
                            "netArea": {
                                "show": false,
                                "interval": {
                                    "value": "auto",
                                    "cusNumber": 0
                                },
                                "colorOne": "auto",
                                "colorTwo": "auto"
                            },
                            "data": [
                                "尔尔",
                                "树人",
                                "多个"
                            ],
                            "type": "category"
                        },
                        "yAxisLeft": {
                            "show": true,
                            "title": {
                                "showTitle": false,
                                "text": "",
                                "nameGap": 15,
                                "rotate": 0,
                                "label": {
                                    "fontSize": 12,
                                    "color": "#333",
                                    "fontFamily": "sans-serif",
                                    "fontGroup": [],
                                    "cusFontSize": 12
                                },
                                "fzPosition": "end"
                            },
                            "name": "显示Y轴",
                            "inverse": false,
                            "tickLine": {
                                "show": true,
                                "width": 1,
                                "color": "auto"
                            },
                            "tick": {
                                "show": true,
                                "position": "outside",
                                "length": 5,
                                "width": 1,
                                "color": "auto"
                            },
                            "tickLabel": {
                                "show": true,
                                "label": {
                                    "fontSize": 12,
                                    "color": "#333",
                                    "fontFamily": "sans-serif",
                                    "fontGroup": [],
                                    "cusFontSize": 12
                                },
                                "rotate": 0,
                                "formatter": {
                                    "prefix": "",
                                    "suffix": "",
                                    "ratio": 1,
                                    "digit": "auto"
                                },
                                "split": 5,
                                "min": null,
                                "max": null,
                                "prefix": "",
                                "suffix": "",
                                "ratio": 1,
                                "digit": "auto",
                                "distance": 0
                            },
                            "netLine": {
                                "show": false,
                                "width": 1,
                                "type": "solid",
                                "color": "auto",
                                "interval": {
                                    "value": "auto",
                                    "cusNumber": 0
                                }
                            },
                            "netArea": {
                                "show": false,
                                "interval": {
                                    "value": "auto",
                                    "cusNumber": 0
                                },
                                "colorOne": "auto",
                                "colorTwo": "auto"
                            },
                            "type": "value"
                        },
                        "yAxisRight": {
                            "show": false,
                            "title": {
                                "showTitle": false,
                                "text": "",
                                "nameGap": 15,
                                "rotate": 0,
                                "label": {
                                    "fontSize": 12,
                                    "color": "#333",
                                    "fontFamily": "sans-serif",
                                    "fontGroup": [],
                                    "cusFontSize": 12
                                },
                                "fzPosition": "end"
                            },
                            "name": "显示Y轴",
                            "inverse": false,
                            "tickLine": {
                                "show": true,
                                "width": 1,
                                "color": "auto"
                            },
                            "tick": {
                                "show": true,
                                "position": "outside",
                                "length": 5,
                                "width": 1,
                                "color": "auto"
                            },
                            "tickLabel": {
                                "show": true,
                                "label": {
                                    "fontSize": 12,
                                    "color": "#333",
                                    "fontFamily": "sans-serif",
                                    "fontGroup": [],
                                    "cusFontSize": 12
                                },
                                "rotate": 0,
                                "formatter": {
                                    "prefix": "",
                                    "suffix": "",
                                    "ratio": 1,
                                    "digit": "auto"
                                },
                                "split": 5,
                                "min": null,
                                "max": null,
                                "prefix": "",
                                "suffix": "",
                                "ratio": 1,
                                "digit": "auto",
                                "distance": 0
                            },
                            "netLine": {
                                "show": false,
                                "width": 1,
                                "type": "solid",
                                "color": "auto",
                                "interval": {
                                    "value": "auto",
                                    "cusNumber": 0
                                }
                            },
                            "netArea": {
                                "show": false,
                                "interval": {
                                    "value": "auto",
                                    "cusNumber": 0
                                },
                                "colorOne": "auto",
                                "colorTwo": "auto"
                            }
                        }
                    },
                    "series": [
                        {
                            "itemStyle": {
                                "color": null,
                                "borderColor": "#000",
                                "borderType": "solid",
                                "borderWidth": 1
                            },
                            "lineStyle": {
                                "color": null,
                                "width": 1,
                                "type": "solid"
                            },
                            "data": [
                                1,
                                3,
                                5
                            ],
                            "type": "line",
                            "name": "尔尔",
                            "markPoint": {
                                "data": []
                            },
                            "markLine": {
                                "data": []
                            },
                            "markArea": {
                                "data": []
                            }
                        },
                        {
                            "itemStyle": {
                                "color": null,
                                "borderColor": "#000",
                                "borderType": "solid",
                                "borderWidth": 1
                            },
                            "lineStyle": {
                                "color": null,
                                "width": 1,
                                "type": "solid"
                            },
                            "data": [
                                2,
                                4,
                                6
                            ],
                            "type": "line",
                            "name": "地方当然",
                            "markPoint": {
                                "data": []
                            },
                            "markLine": {
                                "data": []
                            },
                            "markArea": {
                                "data": []
                            }
                        }
                    ],
                    "seriesData": [
                        [
                            1,
                            3,
                            5
                        ],
                        [
                            2,
                            4,
                            6
                        ]
                    ]
                }
            }
        }, {
            "chart_id": "chart_5erpeWc1eWal_15960973336319",
            "active": true,
            "chartOptions": {
                "chart_id": "chart_5erpeWc1eWal_15960973336319",
                "chartAllType": "echarts|line|default",
                "chartPro": "echarts",
                "chartType": "line",
                "chartStyle": "default",
                "chartData": [
                    [
                        {
                            "v": "德国人的",
                            "ct": {
                                "fa": "General",
                                "t": "g"
                            },
                            "m": "德国人的",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        },
                        {
                            "v": "尔尔",
                            "ct": {
                                "fa": "General",
                                "t": "g"
                            },
                            "m": "尔尔",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        },
                        {
                            "v": "地方当然",
                            "ct": {
                                "fa": "General",
                                "t": "g"
                            },
                            "m": "地方当然",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        }
                    ],
                    [
                        {
                            "v": "尔尔",
                            "ct": {
                                "fa": "General",
                                "t": "g"
                            },
                            "m": "尔尔",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        },
                        {
                            "v": 1,
                            "ct": {
                                "fa": "General",
                                "t": "n"
                            },
                            "m": "1",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        },
                        {
                            "v": 2,
                            "ct": {
                                "fa": "General",
                                "t": "n"
                            },
                            "m": "2",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        }
                    ],
                    [
                        {
                            "v": "树人",
                            "ct": {
                                "fa": "General",
                                "t": "g"
                            },
                            "m": "树人",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        },
                        {
                            "v": 3,
                            "ct": {
                                "fa": "General",
                                "t": "n"
                            },
                            "m": "3",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        },
                        {
                            "v": 4,
                            "ct": {
                                "fa": "General",
                                "t": "n"
                            },
                            "m": "4",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        }
                    ],
                    [
                        {
                            "v": "多个",
                            "ct": {
                                "fa": "General",
                                "t": "g"
                            },
                            "m": "多个",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        },
                        {
                            "v": 5,
                            "ct": {
                                "fa": "General",
                                "t": "n"
                            },
                            "m": "5",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        },
                        {
                            "v": 6,
                            "ct": {
                                "fa": "General",
                                "t": "n"
                            },
                            "m": "6",
                            "bg": "rgba(255,255,255)",
                            "bl": 0,
                            "it": 0,
                            "ff": 1,
                            "fs": 11,
                            "fc": "rgb(0, 0, 0)",
                            "ht": 1,
                            "vt": 0
                        }
                    ]
                ],
                "rangeArray": [
                    {
                        "row": [
                            17,
                            20
                        ],
                        "column": [
                            9,
                            11
                        ],
                        "row_focus": 17,
                        "column_focus": 9,
                        "left": 1077,
                        "width": 140,
                        "top": 357,
                        "height": 31,
                        "left_move": 1077,
                        "width_move": 359,
                        "top_move": 357,
                        "height_move": 94
                    }
                ],
                "rangeTxt": "J18:L21",
                "rangeColCheck": {
                    "exits": true,
                    "range": [
                        0,
                        0
                    ]
                },
                "rangeRowCheck": {
                    "exits": true,
                    "range": [
                        0,
                        0
                    ]
                },
                "rangeConfigCheck": false,
                "rangeSplitArray": {
                    "title": {
                        "row": [
                            0,
                            0
                        ],
                        "column": [
                            0,
                            0
                        ]
                    },
                    "rowtitle": {
                        "row": [
                            0,
                            0
                        ],
                        "column": [
                            1,
                            2
                        ]
                    },
                    "coltitle": {
                        "row": [
                            1,
                            3
                        ],
                        "column": [
                            0,
                            0
                        ]
                    },
                    "content": {
                        "row": [
                            1,
                            3
                        ],
                        "column": [
                            1,
                            2
                        ]
                    },
                    "type": "normal",
                    "range": {
                        "row": [
                            17,
                            20
                        ],
                        "column": [
                            9,
                            11
                        ],
                        "row_focus": 17,
                        "column_focus": 9,
                        "left": 1077,
                        "width": 140,
                        "top": 357,
                        "height": 31,
                        "left_move": 1077,
                        "width_move": 359,
                        "top_move": 357,
                        "height_move": 94
                    }
                },
                "chartDataCache": {
                    "label": [
                        "尔尔",
                        "地方当然"
                    ],
                    "xAxis": [
                        "尔尔",
                        "树人",
                        "多个"
                    ],
                    "series": [
                        [
                            1,
                            2
                        ],
                        [
                            3,
                            4
                        ],
                        [
                            5,
                            6
                        ]
                    ],
                    "series_tpye": {
                        "0": "num",
                        "1": "num"
                    }
                },
                "chartDataSeriesOrder": {
                    "0": 0,
                    "1": 1,
                    "length": 2
                },
                "defaultOption": {
                    "title": {
                        "show": false,
                        "text": "默认标题",
                        "label": {
                            "fontSize": 12,
                            "color": "#333",
                            "fontFamily": "sans-serif",
                            "fontGroup": [],
                            "cusFontSize": 12
                        },
                        "position": {
                            "value": "left-top",
                            "offsetX": 40,
                            "offsetY": 50
                        }
                    },
                    "subtitle": {
                        "show": false,
                        "text": "",
                        "label": {
                            "fontSize": 12,
                            "color": "#333",
                            "fontFamily": "sans-serif",
                            "fontGroup": [],
                            "cusFontSize": 12
                        },
                        "distance": {
                            "value": "auto",
                            "cusGap": 40
                        }
                    },
                    "config": {
                        "color": "transparent",
                        "fontFamily": "Sans-serif",
                        "grid": {
                            "value": "normal",
                            "top": 5,
                            "left": 10,
                            "right": 20,
                            "bottom": 10
                        }
                    },
                    "legend": {
                        "show": true,
                        "selectMode": "multiple",
                        "selected": [
                            {
                                "seriesName": "衣服",
                                "isShow": true
                            },
                            {
                                "seriesName": "食材",
                                "isShow": true
                            },
                            {
                                "seriesName": "图书",
                                "isShow": true
                            }
                        ],
                        "label": {
                            "fontSize": 12,
                            "color": "#333",
                            "fontFamily": "sans-serif",
                            "fontGroup": [],
                            "cusFontSize": 12
                        },
                        "position": {
                            "value": "left-top",
                            "offsetX": 40,
                            "offsetY": 50,
                            "direction": "horizontal"
                        },
                        "width": {
                            "value": "auto",
                            "cusSize": 25
                        },
                        "height": {
                            "value": "auto",
                            "cusSize": 14
                        },
                        "distance": {
                            "value": "auto",
                            "cusGap": 10
                        },
                        "itemGap": 10,
                        "data": [
                            "尔尔",
                            "地方当然"
                        ]
                    },
                    "tooltip": {
                        "show": true,
                        "label": {
                            "fontSize": 12,
                            "color": "#333",
                            "fontFamily": "sans-serif",
                            "fontGroup": [],
                            "cusFontSize": 12
                        },
                        "backgroundColor": "rgba(50,50,50,0.7)",
                        "triggerOn": "mousemove",
                        "triggerType": "item",
                        "axisPointer": {
                            "type": "line",
                            "style": {
                                "color": "#555",
                                "width": "normal",
                                "type": "solid"
                            }
                        },
                        "format": [
                            {
                                "seriesName": "衣服",
                                "prefix": "",
                                "suffix": "",
                                "ratio": 1,
                                "digit": "auto"
                            },
                            {
                                "seriesName": "食材",
                                "prefix": "",
                                "suffix": "",
                                "ratio": 1,
                                "digit": "auto"
                            },
                            {
                                "seriesName": "图书",
                                "prefix": "",
                                "suffix": "",
                                "ratio": 1,
                                "digit": "auto"
                            }
                        ],
                        "position": "auto"
                    },
                    "axis": {
                        "axisType": "xAxisDown",
                        "xAxisUp": {
                            "show": false,
                            "title": {
                                "showTitle": false,
                                "text": "",
                                "nameGap": 15,
                                "rotate": 0,
                                "label": {
                                    "fontSize": 12,
                                    "color": "#333",
                                    "fontFamily": "sans-serif",
                                    "fontGroup": [],
                                    "cusFontSize": 12
                                },
                                "fzPosition": "end"
                            },
                            "name": "显示X轴",
                            "inverse": false,
                            "tickLine": {
                                "show": true,
                                "width": 1,
                                "color": "auto"
                            },
                            "tick": {
                                "show": true,
                                "position": "outside",
                                "length": 5,
                                "width": 1,
                                "color": "auto"
                            },
                            "tickLabel": {
                                "show": true,
                                "label": {
                                    "fontSize": 12,
                                    "color": "#333",
                                    "fontFamily": "sans-serif",
                                    "fontGroup": [],
                                    "cusFontSize": 12
                                },
                                "rotate": 0,
                                "prefix": "",
                                "suffix": "",
                                "optimize": 0,
                                "distance": 0,
                                "min": "auto",
                                "max": "auto",
                                "ratio": 1,
                                "digit": "auto"
                            },
                            "netLine": {
                                "show": false,
                                "width": 1,
                                "type": "solid",
                                "color": "auto",
                                "interval": {
                                    "value": "auto",
                                    "cusNumber": 0
                                }
                            },
                            "netArea": {
                                "show": false,
                                "interval": {
                                    "value": "auto",
                                    "cusNumber": 0
                                },
                                "colorOne": "auto",
                                "colorTwo": "auto"
                            },
                            "axisLine": {
                                "onZero": false
                            }
                        },
                        "xAxisDown": {
                            "show": true,
                            "title": {
                                "showTitle": false,
                                "text": "",
                                "nameGap": 15,
                                "rotate": 0,
                                "label": {
                                    "fontSize": 12,
                                    "color": "#333",
                                    "fontFamily": "sans-serif",
                                    "fontGroup": [],
                                    "cusFontSize": 12
                                },
                                "fzPosition": "end"
                            },
                            "name": "显示X轴",
                            "inverse": false,
                            "tickLine": {
                                "show": true,
                                "width": 1,
                                "color": "auto"
                            },
                            "tick": {
                                "show": true,
                                "position": "outside",
                                "length": 5,
                                "width": 1,
                                "color": "auto"
                            },
                            "tickLabel": {
                                "show": true,
                                "label": {
                                    "fontSize": 12,
                                    "color": "#333",
                                    "fontFamily": "sans-serif",
                                    "fontGroup": [],
                                    "cusFontSize": 12
                                },
                                "rotate": 0,
                                "prefix": "",
                                "suffix": "",
                                "optimize": 0,
                                "distance": 0,
                                "min": null,
                                "max": null,
                                "ratio": 1,
                                "digit": "auto"
                            },
                            "netLine": {
                                "show": false,
                                "width": 1,
                                "type": "solid",
                                "color": "auto",
                                "interval": {
                                    "value": "auto",
                                    "cusNumber": 0
                                }
                            },
                            "netArea": {
                                "show": false,
                                "interval": {
                                    "value": "auto",
                                    "cusNumber": 0
                                },
                                "colorOne": "auto",
                                "colorTwo": "auto"
                            },
                            "data": [
                                "尔尔",
                                "树人",
                                "多个"
                            ],
                            "type": "category"
                        },
                        "yAxisLeft": {
                            "show": true,
                            "title": {
                                "showTitle": false,
                                "text": "",
                                "nameGap": 15,
                                "rotate": 0,
                                "label": {
                                    "fontSize": 12,
                                    "color": "#333",
                                    "fontFamily": "sans-serif",
                                    "fontGroup": [],
                                    "cusFontSize": 12
                                },
                                "fzPosition": "end"
                            },
                            "name": "显示Y轴",
                            "inverse": false,
                            "tickLine": {
                                "show": true,
                                "width": 1,
                                "color": "auto"
                            },
                            "tick": {
                                "show": true,
                                "position": "outside",
                                "length": 5,
                                "width": 1,
                                "color": "auto"
                            },
                            "tickLabel": {
                                "show": true,
                                "label": {
                                    "fontSize": 12,
                                    "color": "#333",
                                    "fontFamily": "sans-serif",
                                    "fontGroup": [],
                                    "cusFontSize": 12
                                },
                                "rotate": 0,
                                "formatter": {
                                    "prefix": "",
                                    "suffix": "",
                                    "ratio": 1,
                                    "digit": "auto"
                                },
                                "split": 5,
                                "min": null,
                                "max": null,
                                "prefix": "",
                                "suffix": "",
                                "ratio": 1,
                                "digit": "auto",
                                "distance": 0
                            },
                            "netLine": {
                                "show": false,
                                "width": 1,
                                "type": "solid",
                                "color": "auto",
                                "interval": {
                                    "value": "auto",
                                    "cusNumber": 0
                                }
                            },
                            "netArea": {
                                "show": false,
                                "interval": {
                                    "value": "auto",
                                    "cusNumber": 0
                                },
                                "colorOne": "auto",
                                "colorTwo": "auto"
                            },
                            "type": "value"
                        },
                        "yAxisRight": {
                            "show": false,
                            "title": {
                                "showTitle": false,
                                "text": "",
                                "nameGap": 15,
                                "rotate": 0,
                                "label": {
                                    "fontSize": 12,
                                    "color": "#333",
                                    "fontFamily": "sans-serif",
                                    "fontGroup": [],
                                    "cusFontSize": 12
                                },
                                "fzPosition": "end"
                            },
                            "name": "显示Y轴",
                            "inverse": false,
                            "tickLine": {
                                "show": true,
                                "width": 1,
                                "color": "auto"
                            },
                            "tick": {
                                "show": true,
                                "position": "outside",
                                "length": 5,
                                "width": 1,
                                "color": "auto"
                            },
                            "tickLabel": {
                                "show": true,
                                "label": {
                                    "fontSize": 12,
                                    "color": "#333",
                                    "fontFamily": "sans-serif",
                                    "fontGroup": [],
                                    "cusFontSize": 12
                                },
                                "rotate": 0,
                                "formatter": {
                                    "prefix": "",
                                    "suffix": "",
                                    "ratio": 1,
                                    "digit": "auto"
                                },
                                "split": 5,
                                "min": null,
                                "max": null,
                                "prefix": "",
                                "suffix": "",
                                "ratio": 1,
                                "digit": "auto",
                                "distance": 0
                            },
                            "netLine": {
                                "show": false,
                                "width": 1,
                                "type": "solid",
                                "color": "auto",
                                "interval": {
                                    "value": "auto",
                                    "cusNumber": 0
                                }
                            },
                            "netArea": {
                                "show": false,
                                "interval": {
                                    "value": "auto",
                                    "cusNumber": 0
                                },
                                "colorOne": "auto",
                                "colorTwo": "auto"
                            }
                        }
                    },
                    "series": [
                        {
                            "itemStyle": {
                                "color": null,
                                "borderColor": "#000",
                                "borderType": "solid",
                                "borderWidth": 1
                            },
                            "lineStyle": {
                                "color": null,
                                "width": 1,
                                "type": "solid"
                            },
                            "data": [
                                1,
                                3,
                                5
                            ],
                            "type": "line",
                            "name": "尔尔",
                            "markPoint": {
                                "data": []
                            },
                            "markLine": {
                                "data": []
                            },
                            "markArea": {
                                "data": []
                            }
                        },
                        {
                            "itemStyle": {
                                "color": null,
                                "borderColor": "#000",
                                "borderType": "solid",
                                "borderWidth": 1
                            },
                            "lineStyle": {
                                "color": null,
                                "width": 1,
                                "type": "solid"
                            },
                            "data": [
                                2,
                                4,
                                6
                            ],
                            "type": "line",
                            "name": "地方当然",
                            "markPoint": {
                                "data": []
                            },
                            "markLine": {
                                "data": []
                            },
                            "markArea": {
                                "data": []
                            }
                        }
                    ],
                    "seriesData": [
                        [
                            1,
                            3,
                            5
                        ],
                        [
                            2,
                            4,
                            6
                        ]
                    ]
                }
            }
        }
    ],
    // store current chart index
    currentChartIndex: null,
    // current chart objects, bind to chartSetting component
    // currentChart: {},
};